import { Tab, Modal } from 'bootstrap';
// import Swiper JS
import(/* webpackPrefetch: true */ /* webpackChunkName: 'swiper' */ 'root/utils/swiper.js');
import { fontAwesomeLoad } from 'root/utils/fontawesome';
import { faSwatchbook } from '@fortawesome/free-solid-svg-icons/faSwatchbook';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faRuler } from '@fortawesome/free-solid-svg-icons/faRuler';

fontAwesomeLoad('.fa-swatchbook', faSwatchbook);
fontAwesomeLoad('.fa-tags', faTags);
fontAwesomeLoad('.fa-ruler', faRuler);
